const StatisticalDept = () =>
  import('@/views/main/promotion/statisticalDept/StatisticalDept.vue')
export default {
  path: '/main/promotion/statisticalDept',
  name: 'PromotionStatisticalDept',
  component: StatisticalDept,
  children: []
}
